import * as ApiNames from './ApiNames';
import * as ProductLines from './ProductLines';
import { CMS_PROFESSIONAL, COMMERCE_PROFESSIONAL, MARKETING, OPERATIONS_STARTER, SALES, SERVICE } from './UpgradeProducts';
const ProductLineMap = {
  [ProductLines.MARKETING]: {
    highlightedPaidProducts: [ApiNames.MARKETING_HUB_STARTER, ApiNames.MARKETING_HUB_PROFESSIONAL, ApiNames.MARKETING_HUB_ENTERPRISE],
    highlightedFreeProduct: ApiNames.HUBSPOT_FREE,
    upgradeProduct: MARKETING
  },
  [ProductLines.SALES]: {
    highlightedPaidProducts: [ApiNames.SALES_HUB_STARTER, ApiNames.SALES_HUB_PROFESSIONAL, ApiNames.SALES_HUB_ENTERPRISE],
    highlightedFreeProduct: ApiNames.HUBSPOT_FREE,
    upgradeProduct: SALES
  },
  [ProductLines.SERVICE]: {
    highlightedPaidProducts: [ApiNames.SERVICE_HUB_STARTER, ApiNames.SERVICE_HUB_PROFESSIONAL, ApiNames.SERVICE_HUB_ENTERPRISE],
    highlightedFreeProduct: ApiNames.HUBSPOT_FREE,
    upgradeProduct: SERVICE
  },
  [ProductLines.CMS]: {
    highlightedPaidProducts: [ApiNames.CMS_HUB_STARTER, ApiNames.CMS_HUB_PROFESSIONAL, ApiNames.CMS_HUB_ENTERPRISE],
    highlightedFreeProduct: ApiNames.HUBSPOT_FREE,
    upgradeProduct: CMS_PROFESSIONAL
  },
  [ProductLines.OPERATIONS]: {
    highlightedPaidProducts: [ApiNames.OPERATIONS_HUB_STARTER, ApiNames.OPERATIONS_HUB_PROFESSIONAL, ApiNames.OPERATIONS_HUB_ENTERPRISE],
    highlightedFreeProduct: ApiNames.HUBSPOT_FREE,
    upgradeProduct: OPERATIONS_STARTER
  },
  [ProductLines.COMMERCE]: {
    highlightedPaidProducts: [ApiNames.COMMERCE_HUB_PROFESSIONAL, ApiNames.COMMERCE_HUB_ENTERPRISE],
    highlightedFreeProduct: ApiNames.HUBSPOT_FREE,
    upgradeProduct: COMMERCE_PROFESSIONAL
  }
};
export const FullProductLineMap = {
  [ProductLines.MARKETING]: {
    highlightedFreeProduct: ApiNames.MARKETING_HUB_FREE,
    highlightedProducts: [ApiNames.MARKETING_HUB_STARTER, ApiNames.MARKETING_HUB_PROFESSIONAL, ApiNames.MARKETING_HUB_ENTERPRISE],
    upgradeProduct: MARKETING
  },
  [ProductLines.SALES]: {
    highlightedFreeProduct: ApiNames.SALES_HUB_FREE,
    // Not in API yet (Features nor Products)
    highlightedProducts: [ApiNames.SALES_HUB_STARTER, ApiNames.SALES_HUB_PROFESSIONAL, ApiNames.SALES_HUB_ENTERPRISE],
    upgradeProduct: SALES
  },
  [ProductLines.SERVICE]: {
    highlightedFreeProduct: ApiNames.SERVICE_HUB_FREE,
    highlightedProducts: [ApiNames.SERVICE_HUB_STARTER, ApiNames.SERVICE_HUB_PROFESSIONAL, ApiNames.SERVICE_HUB_ENTERPRISE],
    upgradeProduct: SERVICE
  },
  [ProductLines.CMS]: {
    highlightedFreeProduct: ApiNames.CMS_HUB_FREE,
    highlightedProducts: [ApiNames.CMS_HUB_STARTER, ApiNames.CMS_HUB_PROFESSIONAL, ApiNames.CMS_HUB_ENTERPRISE],
    upgradeProduct: CMS_PROFESSIONAL
  },
  [ProductLines.OPERATIONS]: {
    highlightedFreeProduct: ApiNames.OPERATIONS_HUB_FREE,
    // Not in API yet (Features nor Products)
    highlightedProducts: [ApiNames.OPERATIONS_HUB_STARTER, ApiNames.OPERATIONS_HUB_PROFESSIONAL, ApiNames.OPERATIONS_HUB_ENTERPRISE],
    upgradeProduct: OPERATIONS_STARTER
  },
  [ProductLines.COMMERCE]: {
    highlightedFreeProduct: ApiNames.COMMERCE_HUB_FREE,
    highlightedProducts: [ApiNames.COMMERCE_HUB_PROFESSIONAL, ApiNames.COMMERCE_HUB_ENTERPRISE],
    upgradeProduct: COMMERCE_PROFESSIONAL
  }
};
export const FullProductLineMapV2 = {
  [ProductLines.MARKETING]: {
    highlightedFreeProduct: ApiNames.MARKETING_HUB_FREE,
    highlightedProducts: [ApiNames.MARKETING_HUB_STARTER, ApiNames.MARKETING_HUB_PROFESSIONAL, ApiNames.MARKETING_HUB_ENTERPRISE],
    upgradeProduct: MARKETING
  },
  [ProductLines.SALES]: {
    highlightedFreeProduct: ApiNames.SALES_HUB_FREE,
    // Not in Merchandise yet, this is strictly used to access feature store
    highlightedProducts: [ApiNames.SALES_HUB_STARTER, ApiNames.SALES_HUB_PROFESSIONAL, ApiNames.SALES_HUB_ENTERPRISE],
    upgradeProduct: SALES
  },
  [ProductLines.SERVICE]: {
    highlightedFreeProduct: ApiNames.SERVICE_HUB_FREE,
    highlightedProducts: [ApiNames.SERVICE_HUB_STARTER, ApiNames.SERVICE_HUB_PROFESSIONAL, ApiNames.SERVICE_HUB_ENTERPRISE],
    upgradeProduct: SERVICE
  },
  [ProductLines.CMS]: {
    highlightedFreeProduct: ApiNames.CMS_HUB_FREE,
    highlightedProducts: [ApiNames.CMS_HUB_STARTER, ApiNames.CMS_HUB_PROFESSIONAL, ApiNames.CMS_HUB_ENTERPRISE],
    upgradeProduct: CMS_PROFESSIONAL
  },
  [ProductLines.OPERATIONS]: {
    highlightedFreeProduct: ApiNames.OPERATIONS_HUB_FREE,
    // Not in Merchandise yet, this is strictly used to access feature store
    highlightedProducts: [ApiNames.OPERATIONS_HUB_STARTER, ApiNames.OPERATIONS_HUB_PROFESSIONAL, ApiNames.OPERATIONS_HUB_ENTERPRISE],
    upgradeProduct: OPERATIONS_STARTER
  },
  [ProductLines.COMMERCE]: {
    highlightedFreeProduct: ApiNames.COMMERCE_HUB_FREE,
    // Not in Merchandise yet, this is strictly used to access feature store
    highlightedProducts: [ApiNames.COMMERCE_HUB_PROFESSIONAL, ApiNames.COMMERCE_HUB_ENTERPRISE],
    upgradeProduct: COMMERCE_PROFESSIONAL
  }
};
export default ProductLineMap;